import * as Yup from "yup";

// form field names
export type TFormFieldNames = "account_id" | "description" | "contact_name" | "contact_phone" | "timezone" | "user_name" | "contact_email";

// initial values for the form
export const formInitialValues = {
  account_id: "",
  description: "",
  contact_name: "",
  contact_phone: "",
  timezone: "",
  user_name: "",
  contact_email: "",
};

// validation schema for the form
export const YupValidationSchema = Yup.object().shape({
  account_id: Yup.string()
    .required("Please enter the account ID")
    .matches(/^[a-z0-9\-_]+$/, 'Only lowercase characters, numbers, hyphens, and underscores are allowed'),

  contact_name: Yup.string().required("Please enter the contact name"),

  contact_phone: Yup.string()
    .required("Phone number is required")
    .matches(/^\d{10}$/, 'Please enter a valid phone number'),

  timezone: Yup.string().required("Please select a timezone"),

  contact_email: Yup.string()
    .matches(/^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/, 'Please enter a valid email address'),

});